export const Myadzyel = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.453272983266174, 54.802802572570556],
            [26.467289799384787, 54.79607311688096],
            [26.487323863505537, 54.783531818238885],
            [26.501633910077032, 54.77296770699405],
            [26.515943956648414, 54.76339159814381],
            [26.527391994445054, 54.75546482883891],
            [26.536192673653034, 54.74797012801912],
            [26.551397097797974, 54.74435648386469],
            [26.56302401074953, 54.74590522794398],
            [26.574650923701256, 54.74177511213179],
            [26.576439679747466, 54.73506277652609],
            [26.575239438821427, 54.73392869752382],
            [26.5817002765055, 54.73262307226844],
            [26.59241366453392, 54.72927227383752],
            [26.598663140659312, 54.72849897339108],
            [26.607144571837864, 54.72643676655133],
            [26.609376527789493, 54.72385886030304],
            [26.61205487457204, 54.719991694003284],
            [26.615626003914713, 54.716897695319915],
            [26.620982698378157, 54.71586630960496],
            [26.62946412955671, 54.71560845933601],
            [26.635267214851126, 54.71560845933601],
            [26.641516690976516, 54.716382005742105],
            [26.645534211150277, 54.718702556408914],
            [26.647766167101906, 54.72128079060309],
            [26.649551731324095, 54.725921198315234],
            [26.652230079004994, 54.73004555952758],
            [26.65446203405827, 54.73623131435522],
            [26.655801207449485, 54.74009693125362],
            [26.658033163401115, 54.74318915919309],
            [26.66338985696609, 54.74318915919309],
            [26.66740737803815, 54.74318915919309],
            [26.672764071603353, 54.74293148272062],
            [26.677227982608088, 54.74421984972673],
            [26.679906330288986, 54.7460234942705],
            [26.681245503680145, 54.74937290741644],
            [26.683477458733478, 54.75220680973956],
            [26.68794137063651, 54.75787401887038],
            [26.69106610914838, 54.76096489010098],
            [26.696422802713528, 54.76405552480412],
            [26.701779496278505, 54.764828146604486],
            [26.706689799012736, 54.76354043523651],
            [26.709814536626254, 54.76044976119914],
            [26.712492884307153, 54.75890433567719],
            [26.71963514209432, 54.75632849500806],
            [26.724545444828493, 54.7560709021339],
            [26.73034853012291, 54.75581330762054],
            [26.73525883285697, 54.75529811315852],
            [26.73838357047049, 54.75220680973956],
            [26.740169135590975, 54.747827059009126],
            [26.740615526421948, 54.74601318786057],
            [26.740901216733505, 54.74469395819142],
            [26.74118690704495, 54.7427150331132],
            [26.741758287667892, 54.74040616446314],
            [26.742043977979506, 54.738427029884804],
            [26.74432950047145, 54.73661273824291],
            [26.747472094796137, 54.736942615494115],
            [26.75032899791114, 54.73793223113137],
            [26.753185901026086, 54.740241240274884],
            [26.757471256596773, 54.742550118325596],
            [26.76147092095772, 54.74337468554933],
            [26.76947025057774, 54.744199235986514],
            [26.772898534315686, 54.744034327241934],
            [26.777183889886373, 54.74304486067422],
            [26.780897863935763, 54.74189045246021],
            [26.782897696116322, 54.74073601082546],
            [26.785754600129565, 54.73908675215489],
            [26.787754432309953, 54.737437426334566],
            [26.790611335424956, 54.73496331117707],
            [26.795468071618586, 54.73397362301523],
            [26.799182045667976, 54.73397362301523],
            [26.802324639094536, 54.73512825685356],
            [26.80632430435361, 54.73677767720426],
            [26.80946689778017, 54.73925168104353],
            [26.811752420272114, 54.741065854501755],
            [26.81632346615436, 54.743539596979645],
            [26.818894678957747, 54.74502376963733],
            [26.825179865810526, 54.74617808854782],
            [26.831750743873158, 54.74584828650205],
            [26.834036266365104, 54.74469395819142],
            [26.83660748006696, 54.74205536993384],
            [26.837464551001403, 54.740076315415024],
            [26.83832162193596, 54.73595297568221],
            [26.838607312247348, 54.731994174165436],
            [26.83889300255879, 54.728859848527065],
            [26.83975007349335, 54.72539531238323],
            [26.84146421536235, 54.72325045058858],
            [26.845463879723127, 54.722260476332394],
            [26.85146337716293, 54.725230327084034],
            [26.85517735121232, 54.728034985832664],
            [26.859748397094563, 54.73364372158903],
            [26.86174822927495, 54.73529320185855],
            [26.86489082270134, 54.738921822594534],
            [26.865176513012898, 54.74090093299935],
            [26.865176513012898, 54.7453535783975],
            [26.86260530020951, 54.748156844940695],
            [26.858319945537005, 54.75161943507476],
            [26.85317751903193, 54.754752000108965],
            [26.85146337716293, 54.75738976119197],
            [26.852891828720317, 54.760851562315395],
            [26.856034422146706, 54.76184059382541],
            [26.860891158340337, 54.76249993473937],
            [26.863462371143896, 54.761675756918805],
            [26.866890655780196, 54.75903827459382],
            [26.869747558895142, 54.75689519408024],
            [26.87231877169853, 54.75425740077219],
            [26.87488998450192, 54.75194919012148],
            [26.878318269138163, 54.75063015382102],
            [26.88346069474511, 54.74964084839695],
            [26.8888888115618, 54.74914618662092],
            [26.89403123716852, 54.74898129801926],
            [26.899745044296765, 54.748156844940695],
            [26.902316257100324, 54.74634298856358],
            [26.904316089280712, 54.743539596979645],
            [26.9051731602151, 54.73958153680667],
            [26.906601611772714, 54.73644779860996],
            [26.9080300642284, 54.73446847011809],
            [26.910886967343345, 54.73331381747664],
            [26.915172322015735, 54.73232408902243],
            [26.920029058209366, 54.73050952406601],
            [26.92145750976698, 54.728199959714686],
            [26.922600271012925, 54.7247353671566],
            [26.922600271012925, 54.720775469612875],
            [26.922600271012925, 54.718630363860996],
            [26.924885793504927, 54.71466986988594],
            [26.9265999353737, 54.71136916260701],
            [26.927171316895, 54.707407959823115],
            [26.9265999353737, 54.70427173268769],
            [26.925742864439314, 54.70113526355726],
            [26.925742864439314, 54.69915421021011],
            [26.927171316895, 54.69717306063893],
            [26.93088529094456, 54.69700796047448],
            [26.93202805219056, 54.69717306063893],
            [26.934313574682506, 54.697998551384046],
            [26.936313406862894, 54.6994843923996],
            [26.940884452745138, 54.70113526355726],
            [26.94431273648297, 54.70146542962311],
            [26.94859809205377, 54.70113526355726],
            [26.95316913703755, 54.69964948248662],
            [26.95488327890655, 54.69783345457864],
            [26.956311730464108, 54.69667775812991],
            [26.958597253854236, 54.6948615971973],
            [26.963739679461128, 54.69321047073936],
            [26.968025035031815, 54.69304535445019],
            [26.97516729281932, 54.69304535445019],
            [26.980881099947396, 54.69304535445019],
            [26.986594906177345, 54.6948615971973],
            [26.989451810190587, 54.69750325895262],
            [26.992308713305363, 54.69981457190181],
            [26.998022520433608, 54.70179559300169],
            [27.004307707286557, 54.70328129495181],
            [27.01144996597219, 54.704601873225386],
            [27.014306869087136, 54.705592278715585],
            [27.016592391578968, 54.70773807483346],
            [27.018592224657823, 54.70938860958057],
            [27.022306198707156, 54.710378898184956],
            [27.027734314625548, 54.710543943934624],
            [27.03059121863879, 54.70955365936061],
            [27.033448121753793, 54.707407959823115],
            [27.03916192888181, 54.704932011075925],
            [27.046875567292318, 54.705427212813504],
            [27.052589374420393, 54.70575734394623],
            [27.059160252483025, 54.705922408504875],
            [27.064874058712974, 54.70410666141123],
            [27.065445439335974, 54.702125753693224],
            [27.064302678089973, 54.6994843923996],
            [27.057446109715727, 54.69783345457864],
            [27.051446613174562, 54.69618244957411],
            [27.04744694791532, 54.694201154364976],
            [27.044590044800373, 54.69172439994901],
            [27.04430435448876, 54.6884218250471],
            [27.04544711573476, 54.6833023036009],
            [27.046875567292318, 54.68082488346215],
            [27.048875400371003, 54.67818213588441],
            [27.05087523255139, 54.67653033076914],
            [27.055160587223952, 54.674382884328566],
            [27.060874394352027, 54.67355691314856],
            [27.06715958120492, 54.673226519972275],
            [27.076015981759554, 54.672565725555216],
            [27.080872717953184, 54.67273092516763],
            [27.08972911850782, 54.67273092516763],
            [27.09030049913082, 54.67273092516763],
            [27.096871376295155, 54.66810508146574],
            [27.098585518164157, 54.664139653125744],
            [27.098871208475543, 54.65984333611158],
            [27.098585518164157, 54.655877101212184],
            [27.096014305360598, 54.65240632800413],
            [27.09144326037682, 54.64943114403985],
            [27.088300666051964, 54.64711696096731],
            [27.08544376293696, 54.64348012216993],
            [27.085729453248575, 54.6411656002731],
            [27.09030049913082, 54.64017362220221],
            [27.096014305360598, 54.64066961426295],
            [27.103727944669174, 54.64066961426295],
            [27.106013467161176, 54.63901628386236],
            [27.108584679964736, 54.63670150835122],
            [27.10572777684979, 54.634551955432414],
            [27.103727944669174, 54.63207156146899],
            [27.1020138028004, 54.62810261593228],
            [27.101156731865842, 54.62628338669498],
            [27.1008710415544, 54.622975488199245],
            [27.101728112488786, 54.620163563433664],
            [27.103442254357788, 54.61900565557198],
            [27.11172727428942, 54.618343978621965],
            [27.11258434522398, 54.618343978621965],
            [27.116012628961755, 54.61983273597849],
            [27.120297984532613, 54.62181766036139],
            [27.12429764889339, 54.622810086239724],
            [27.12686886169695, 54.622810086239724],
            [27.133725430071024, 54.62165225369472],
            [27.139439236300916, 54.62065979957299],
            [27.14458166280616, 54.62065979957299],
            [27.154580824606626, 54.62181766036139],
            [27.160866012357815, 54.62198306635554],
            [27.170579483847007, 54.62247928030348],
            [27.180578645647472, 54.6252910455446],
            [27.18400692938542, 54.62793723481815],
            [27.187149522811808, 54.630583252474366],
            [27.19257763962861, 54.6322369257731],
            [27.197434374923944, 54.632402289404865],
            [27.20229111111763, 54.63157546452214],
            [27.20686215610158, 54.63091399251306],
            [27.21400441478721, 54.63041788144619],
            [27.223717886276233, 54.6302525092259],
            [27.22828893126018, 54.63124472986243],
            [27.233431357765426, 54.632402289404865],
            [27.238002402749203, 54.635378719802134],
            [27.238002402749203, 54.63885094712447],
            [27.241430687385446, 54.64215755466108],
            [27.244001900188834, 54.64546389275915],
            [27.246001732369393, 54.648769962469544],
            [27.244001900188834, 54.651745194834234],
            [27.240287925241148, 54.65389383883189],
            [27.238573783372203, 54.65620763553153],
            [27.23828809306076, 54.66033908818656],
            [27.23885947368376, 54.662487277275545],
            [27.243144829254447, 54.664470120230476],
            [27.25114415797617, 54.66628764176994],
            [27.258286416661804, 54.66711376080394],
            [27.264285914101606, 54.66827029922382],
            [27.27028541064294, 54.669261591658255],
            [27.276570598394017, 54.66959201709318],
            [27.285998379571595, 54.669426804711804],
            [27.29714030261823, 54.6690963779327],
            [27.30399687099242, 54.669261591658255],
            [27.311139128779757, 54.671904920385714],
            [27.321138290580166, 54.67702587920394],
            [27.3282805492658, 54.67983387328013],
            [27.335994188574603, 54.682971989201235],
            [27.342565066637235, 54.68610986306385],
            [27.347993182555626, 54.68891722833797],
            [27.35113577598196, 54.69106390657328],
            [27.352564227539403, 54.69436626595109],
            [27.353992679995258, 54.698824025333124],
            [27.355992512175646, 54.70262098969192],
            [27.360563557159594, 54.70377651684265],
            [27.364563222418838, 54.70394158946277],
            [27.367705815845227, 54.70113526355726],
            [27.368562886779785, 54.69915421021011],
            [27.369705648025786, 54.695191814322584],
            [27.371419789894617, 54.69321047073936],
            [27.37599083577686, 54.69271511985619],
            [27.38056188076081, 54.69288023748902],
            [27.388275520069442, 54.694201154364976],
            [27.396846230312462, 54.69651265594979],
            [27.402560036542354, 54.69783345457864],
            [27.4077024630476, 54.70030983611656],
            [27.412273508031376, 54.70427173268769],
            [27.418273005471065, 54.706582660541244],
            [27.422844050455012, 54.70691278226923],
            [27.4291292382062, 54.70691278226923],
            [27.43227183163259, 54.70691278226923],
            [27.435985806580277, 54.706087472391914],
            [27.443128064367784, 54.706252535607064],
            [27.44684203931547, 54.707407959823115],
            [27.450556013364803, 54.7092235591287],
            [27.45198446492219, 54.71120412021611],
            [27.45198446492219, 54.713679686069895],
            [27.449984632741803, 54.71615510027061],
            [27.446556349003856, 54.718135322818],
            [27.439985470941224, 54.72110547580769],
            [27.436271496891834, 54.72308545655824],
            [27.43512873564589, 54.7247353671566],
            [27.433128902566978, 54.726880149853855],
            [27.43398597439989, 54.729519726594106],
            [27.436271496891834, 54.731499296843026],
            [27.4454671542984, 54.73648903345145],
            [27.450270323053417, 54.73908675215489],
            [27.45141308429919, 54.74189045246021],
            [27.453412916479806, 54.74551848177043],
            [27.45484136893549, 54.747991952310656],
            [27.458555342984823, 54.75079503570856],
            [27.46426915011307, 54.751289677342356],
            [27.468268814474015, 54.749970619557246],
            [27.468840195097016, 54.747991952310656],
            [27.470840027277404, 54.74601318786057],
            [27.477410905340037, 54.7445290514612],
            [27.48569592527167, 54.74386941782603],
            [27.494838016137862, 54.74337468554933],
            [27.502837344859586, 54.74337468554933],
            [27.515407720361907, 54.74370450773847],
            [27.5222642878378, 54.74485886424998],
            [27.528549475589045, 54.7471674785707],
            [27.529977927146433, 54.750959916924614],
            [27.534834662441824, 54.75508172964334],
            [27.539691398635625, 54.75738976119197],
            [27.549976250747648, 54.760027350929136],
            [27.56026110285967, 54.76249993473937],
            [27.56520351792051, 54.763640560161946],
            [27.56343936873202, 54.766693960857594],
            [27.562294565042293, 54.77131681521894],
            [27.56401177012725, 54.777919977625004],
            [27.56458417242169, 54.78518221089041],
            [27.565728976111416, 54.79079304426358],
            [27.565728976111416, 54.797063053717125],
            [27.562866966437355, 54.80168243759448],
            [27.554853340609213, 54.805311584262256],
            [27.54397770510718, 54.80597139436446],
            [27.53310207050413, 54.8043218497736],
            [27.523371237792446, 54.80135249971818],
            [27.518792023033598, 54.79574313223992],
            [27.514785210569187, 54.79376316953483],
            [27.507343986136107, 54.79640309792467],
            [27.504481976462046, 54.8020123736722],
            [27.507916388430772, 54.8043218497736],
            [27.511958975926063, 54.809868175675774],
            [27.5110645974533, 54.82378218599928],
            [27.502120819020604, 54.82996465094794],
            [27.486022016403012, 54.83563108041017],
            [27.475289481924108, 54.842841748348064],
            [27.46187381292617, 54.84902129589625],
            [27.452035655121506, 54.85211071443803],
            [27.441303120642544, 54.851080934038066],
            [27.42699307407122, 54.84850637017303],
            [27.41268302749984, 54.847476498042],
            [27.401950493020934, 54.84850637017303],
            [27.392112336115474, 54.85005112845698],
            [27.376013533497883, 54.85777403494393],
            [27.371541643831847, 54.86395129551596],
            [27.367964131739427, 54.87218617075524],
            [27.363492242972768, 54.87784667188657],
            [27.357231597260466, 54.88402085677717],
            [27.34471030673535, 54.88967969686064],
            [27.334872149829835, 54.888650876037275],
            [27.322350858405514, 54.89122287863307],
            [27.319596174723813, 54.90120069305772],
            [27.319596174723813, 54.908111709587786],
            [27.323030585792992, 54.91271839503793],
            [27.329327006536175, 54.92127226880035],
            [27.32818220284645, 54.924890668569674],
            [27.321885782103266, 54.92949543306787],
            [27.310437745205945, 54.93311309269524],
            [27.297844903719408, 54.93903219837745],
            [27.28868647420154, 54.94593671910434],
            [27.277238436404843, 54.953497454444005],
            [27.269797211971763, 54.95875625629628],
            [27.27036961426643, 54.965000190806336],
            [27.27437642763016, 54.969928927078456],
            [27.277238436404843, 54.9758426125465],
            [27.275106115888093, 54.98012561585551],
            [27.274948829025277, 54.98044154404204],
            [27.268652408282094, 54.98471150802976],
            [27.25548716540044, 54.984054619824974],
            [27.24632873588257, 54.98274081193904],
            [27.238315110054373, 54.981098490702834],
            [27.231446287915958, 54.97978458569014],
            [27.221143053808987, 54.984383065726036],
            [27.21599143675553, 54.98832419980198],
            [27.207977810927332, 54.992921701375565],
            [27.19996418509919, 54.991279796525475],
            [27.18908854959699, 54.991279796525475],
            [27.183364530249037, 54.992921701375565],
            [27.178785315490018, 54.992921701375565],
            [27.170199288266588, 54.989637825125556],
            [27.16504767121313, 54.98471150802976],
            [27.15760644678022, 54.98372617212516],
            [27.148448017262353, 54.98372617212516],
            [27.13928958684511, 54.98701053131106],
            [27.129558755032576, 54.988981017859714],
            [27.11982792411942, 54.98865261062957],
            [27.110669493702176, 54.98865261062957],
            [27.098649055409624, 54.98865261062957],
            [27.090063026387668, 54.99095140818105],
            [27.08090459776895, 54.99160818307132],
            [27.073463373336097, 54.989637825125556],
            [27.071173765057267, 54.98602525206388],
            [27.072890971041602, 54.978142143944865],
            [27.070028962266917, 54.97321441581283],
            [27.06029813045444, 54.97091460202739],
            [27.048277691262513, 54.97321441581283],
            [27.035684849776146, 54.97321441581283],
            [27.029388429032906, 54.971571705170106],
            [27.025381615669176, 54.969271796956036],
            [27.005919952943543, 54.964671586624604],
            [26.997906327115345, 54.964014371066355],
            [26.98016186947467, 54.963028527045026],
            [26.965851822903346, 54.96269990667554],
            [26.96184500953956, 54.96269990667554],
            [26.95612099109104, 54.964014371066355],
            [26.95383138281221, 54.969600363366226],
            [26.954976187401314, 54.973871481184005],
            [26.957838196176, 54.98306926773262],
            [26.94982457034763, 54.98865261062957],
            [26.935514523776305, 54.99522025431128],
            [26.927500897948107, 54.99916032538869],
            [26.920059673515254, 55.00277171674139],
            [26.909756439408284, 55.00638278253945],
            [26.89201198176761, 55.00900880920915],
            [26.881136346265407, 55.00474142897383],
            [26.866826299694026, 54.99784701123065],
            [26.85652306648643, 54.99357844389016],
            [26.84564743098423, 54.992921701375565],
            [26.843357823604833, 54.99554860848161],
            [26.827902973343726, 54.99981696538066],
            [26.821034150305934, 54.99916032538869],
            [26.815882534151797, 54.99784701123065],
            [26.8147377304619, 54.994235176512234],
            [26.815310132756565, 54.98766737095258],
            [26.817599739236584, 54.981098490702834],
            [26.817027337841523, 54.97124315494773],
            [26.817599739236584, 54.96434298064412],
            [26.815882534151797, 54.95875625629628],
            [26.803862094959868, 54.96237128360792],
            [26.792414057163057, 54.96269990667554],
            [26.784972832730148, 54.963028527045026],
            [26.774669599522554, 54.96237128360792],
            [26.76436636631479, 54.965000190806336],
            [26.750056319743408, 54.96105676615696],
            [26.743187497604993, 54.956455615134644],
            [26.740325487931102, 54.953168755833474],
            [26.73345666579246, 54.94922417015937],
            [26.723725833980154, 54.9508677945131],
            [26.712277796183457, 54.95514090342999],
            [26.69911255330186, 54.95974220553853],
            [26.69338853575249, 54.96368575879086],
            [26.679650890576227, 54.967628925334736],
            [26.668202853678906, 54.97025748809273],
            [26.655037609897875, 54.972228797521154],
            [26.63614834856753, 54.972228797521154],
            [26.622410704290587, 54.97091460202739],
            [26.612107470183673, 54.969600363366226],
            [26.604093844355475, 54.96697175744072],
            [26.60237663837131, 54.963028527045026],
            [26.607528255424825, 54.95908490904151],
            [26.614969479857734, 54.954812219208634],
            [26.614397078462446, 54.9508677945131],
            [26.61039026509866, 54.94659423143867],
            [26.60180423697608, 54.94067623911724],
            [26.590356199179382, 54.937059260276726],
            [26.581197769661514, 54.93377081367208],
            [26.5743289475231, 54.932784228609364],
            [26.567460125384628, 54.9373880892889],
            [26.554294881603596, 54.94067623911724],
            [26.541129638721998, 54.94330656544571],
            [26.52910920042939, 54.94823796281173],
            [26.518805966322475, 54.94922417015937],
            [26.507357929424984, 54.946922983109175],
            [26.495337490233055, 54.944950431717075],
            [26.48675146211042, 54.944950431717075],
            [26.477020630297943, 54.946922983109175],
            [26.468434602175307, 54.95053907521833],
            [26.458131368967543, 54.95415484177255],
            [26.449545340844963, 54.95514090342999],
            [26.440959312722157, 54.95546958585277],
            [26.429511275824837, 54.95842760175253],
            [26.414628826958847, 54.96237128360792],
            [26.407187602525937, 54.965328792289995],
            [26.395739565628503, 54.969600363366226],
            [26.38600873381614, 54.974528535763284],
            [26.376277902003665, 54.9774851487208],
            [26.364257462811736, 54.980113065765465],
            [26.356816239278203, 54.97912761654635],
            [26.353381827309533, 54.97518557955084],
            [26.35109221993008, 54.97124315494773],
            [26.353381827309533, 54.9659859862644],
            [26.356243836983538, 54.96072812959949],
            [26.347814325071056, 54.956400408452225],
            [26.329647274202443, 54.956400408452225],
            [26.315672618996246, 54.956400408452225],
            [26.305890360351896, 54.95319058417829],
            [26.293313171565785, 54.94516490024006],
            [26.287723309483283, 54.94115145797349],
            [26.27791631048939, 54.939743101663],
            [26.278397183383447, 54.93311309269524],
            [26.287723309483283, 54.92107823377353],
            [26.305890360351896, 54.91465268567299],
            [26.325454877640595, 54.91063619740265],
            [26.339429531947417, 54.91063619740265],
            [26.358994049236173, 54.90099499022676],
            [26.363186445797965, 54.892155188711115],
            [26.364583911318505, 54.882509555971296],
            [26.356199118194866, 54.87768587310461],
            [26.356199118194866, 54.86964511832758],
            [26.356199118194866, 54.86079843609906],
            [26.358994049236173, 54.852754313361004],
            [26.352006721633074, 54.838270848720754],
            [26.345019394029976, 54.83263698640792],
            [26.349211790591824, 54.82297710660822],
            [26.357596583715463, 54.81573068072646],
            [26.368776307880353, 54.811704326893164],
            [26.377161101004162, 54.81331491645034],
            [26.388340825169053, 54.81734111020421],
            [26.40511041051718, 54.81653590310947],
            [26.414892668262155, 54.821366901961085],
            [26.427469858846962, 54.825392293519656],
            [26.440047047633243, 54.82378218599928],
            [26.45122677179819, 54.81573068072646],
            [26.449829306277593, 54.804455877536896],
            [26.453272983266174, 54.802802572570556],
          ],
        ],
      },
      properties: {
        shapeName: "Myadzyel",
        shapeISO: "",
        shapeID: "67162791B89573771278316",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
